export const auth = {
  data () {
    return {
      showLogin: false,
      zalogowany: false,
      userData: {}
    }
  },
  watch: {
    userData (newValue) {
      this.userData = newValue
    },
    zalogowany (newValue) {
      this.zalogowany = newValue
    }
  },
  methods: {
    logout () {
      // sessionStorage.clear()
      localStorage.clear()
      this.userData = {}
      this.showLogin = false
      this.zalogowany = false
      this.$router.go(this.$router.currentRoute)
    }
  },
  created () {
    if (localStorage && localStorage.length === 0) {
      this.showLogin = false
    } else {
      if (localStorage.userData !== undefined) {
        this.userData = JSON.parse(localStorage.userData)
        this.zalogowany = true
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/auth.js